import React, { useState } from 'react'

import Text from 'components/common/Text'
import TextButton from 'components/common/TextButton'
import TitleWithIcon from 'components/common/TitleWithIcon'
import Icon from 'components/Icon'
import { InviteUsersModal } from 'components/rbac-settings/InviteUsersModal'
import useAuth from 'hooks/use-auth'
import theme from 'theme'
import { Company } from 'types/api/rbac/company'
import { Team } from 'types/api/teams'
import { FetchFunc } from 'types/util'
import { companiesIdInvitesPost } from 'utils/endpoints-access'

const UsersIcon = (props) => <Icon icon="users" {...props} />

export const TeamSection: React.FC<{
  doFetch: FetchFunc
  company: Company
  teams: Team[]
  isLoading: boolean
}> = ({ doFetch, company, teams, isLoading, ...rest }) => {
  const { currentTeam, hasEndpointAccess } = useAuth()
  const [isModalOpen, setIsModalOpen] = useState(false)

  // this is only a shallow check, the invite modal will check the privileges for each team
  const canInviteTeamMembers = hasEndpointAccess(companiesIdInvitesPost)

  return (
    <div
      css={{
        zIndex: 0,
        display: 'grid',
        gap: theme.space[1],
        justifyItems: 'end'
      }}
      {...rest}
      data-testid="dashboard-team-header"
    >
      {isLoading ? (
        <Text>Fetching team...</Text>
      ) : (
        <TitleWithIcon
          as="h4"
          css={{
            justifyContent: 'flex-end'
          }}
          data-testid="dashboard-team-name"
          icon={UsersIcon}
          label={currentTeam.name}
        />
      )}
      {canInviteTeamMembers && (
        <div>
          <TextButton
            css={{
              display: 'inline-block',
              fontSize: theme.fontSizes[0],
              textAlign: 'right',
              fontWeight: theme.fontWeights[1]
            }}
            onClick={() => setIsModalOpen(true)}
          >
            + Invite your team members
          </TextButton>
          <InviteUsersModal
            company={company}
            data-testid="dashboard-invite-user-modal"
            doFetch={doFetch}
            isOpen={isModalOpen}
            setIsOpen={setIsModalOpen}
            teams={teams}
          />
        </div>
      )}
    </div>
  )
}
